export default __webpack_public_path__ + "img/b69db8afa8d824e403f172c1c8a8c1e7.png";